/* eslint-disable @typescript-eslint/no-explicit-any */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import * as Types from 'src/graphql/schema';

export type IUpdateCustomIntegrationMutationVariables = Types.Exact<{
  customIntegrationInput: Types.ICustomIntegrationUpdateInputAttributes;
  integrationId: Types.Scalars['ID']['input'];
}>;

export type IUpdateCustomIntegrationMutation = {
  __typename?: 'Mutation';
  updateCustomIntegration?: {
    __typename?: 'UpdateCustomIntegrationPayload';
    success: boolean;
    errors?: Array<string> | null;
    customIntegration?: {
      __typename?: 'CustomIntegration';
      accountName?: string | null;
      accountUrl?: string | null;
      active: boolean;
      id: string;
      provider: string;
      status: Types.IntegrationStatusEnum;
    } | null;
  } | null;
};

export const UpdateCustomIntegrationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateCustomIntegration' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'customIntegrationInput' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CustomIntegrationUpdateInputAttributes' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'integrationId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateCustomIntegration' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'customIntegrationInput' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'customIntegrationInput' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'integrationId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'integrationId' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errors' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customIntegration' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'accountName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'accountUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IUpdateCustomIntegrationMutation, IUpdateCustomIntegrationMutationVariables>;
